import React from "react";

import "./styles/landing.css"

const Landing = () => {
    return (
        <div>
            <img class="pdf" 
                src="FactoryRender.png"
                alt="FactoryRender">
            </img>   
        </div>
    )
}

export default Landing;